import { rem } from "polished";
import styled from "styled-components";

import { Button } from "@/components/button";
import { Typography } from "@/components/editor/shared/typography";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  ColorLabels,
  getInvertedColor,
} from "@/components/editor/utils/colors";

export const Title = withViewportStyle("div")`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${rem(40)};

  ${(props) => props.$viewport.mobile`
    margin-bottom: ${rem(24)};
  `}
`;

export const FilterWrapper = withViewportStyle("div")`
  .filter-menu {
    position: relative;
    margin-right: ${rem(16)};

    ${(props) => props.$viewport.mobile`
      margin: 0;
    `}
  }
`;

export const StyledButton = styled(Button)`
  border: ${rem(2)} solid ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
  color: ${({ theme }) =>
    getInvertedColor(theme.colors[ColorLabels.SECONDARY])};
  background: ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
  border-radius: 0;
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  font-size: ${rem(15)};
  font-weight: 600;
  width: 100%;
  justify-content: center;

  &:hover {
    border: ${rem(2)} solid
      ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
    background: ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
    color: ${({ theme }) =>
      getInvertedColor(theme.colors[ColorLabels.SECONDARY])};
  }

  svg {
    color: ${({ theme }) =>
      getInvertedColor(theme.colors[ColorLabels.SECONDARY])};
  }
`;

export const ScheduleDisplayItemWrapper = withViewportStyle("div")`
  display: grid;
  gap: ${rem(8)};
  padding: ${rem(24)} 0;
  border-bottom: 1px solid ${(props) =>
    props.theme.colors[ColorLabels.VISUALS]};
  grid-template-columns: 1fr 1.5fr;

  ${(props) => props.$viewport.mobile`
    grid-template-columns: 1fr;
  `}
`;

export const ScheduleDisplayItemColumn = styled.div`
  display: grid;
  grid-auto-rows: max-content;
`;

export const ScheduleItemType = styled.div`
  padding: 0 ${rem(12)};
  width: max-content;
  line-height: ${rem(32)};
  background-color: ${(props) => props.theme.colors[ColorLabels.PRIMARY]};
`;

export const StyledSegmentText = styled(Typography).attrs({
  pattern: "labelOne",
})`
  font-weight: 600;
  color: ${(props) =>
    getInvertedColor(props.theme.colors[ColorLabels.PRIMARY])};
`;

export const StyledMenuContent = withViewportStyle("div")<{
  $editing: boolean;
  $withBorder?: boolean;
}>`
  position: absolute;
  top: 100%;
  right: 0;
  min-width: ${rem(225)};
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  box-shadow: 0 ${rem(5)} ${rem(20)} rgba(0, 0, 0, 0.33);
  padding: ${rem(24)};
  margin-top: ${rem(8)};
  border: ${({ theme, $withBorder }) =>
    $withBorder
      ? `${rem(2)} solid ${theme.colors[ColorLabels.VISUALS]}`
      : "none"};
  -webkit-tap-highlight-color: transparent;
  z-index: var(--z-index-highest);

  ${(props) => props.$viewport.mobile`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: var(--z-index-highest);
    margin-top: unset;

    ${
      props.$editing &&
      `
      max-width: ${rem(364)};
      left: ${rem(48)};
      `
    }
  `}
`;
